import { useState } from "react";
import { Menu, ShieldCheck } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import AuroraSlideMenu from "./AuroraSlideMenu";

export default function AuroraHeader({ ctaLabel = "Sign In", ctaHref = "/" }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <header
        data-testid="aurora-public-header"
        className="fixed top-0 left-0 right-0 z-40"
      >
        <div className="relative">
          {/* Glass layer */}
          <div className="absolute inset-0 bg-[#0A0A0C]/70 backdrop-blur-2xl border-b border-white/[0.06]" />
          <div className="relative flex items-center justify-between px-6 md:px-10 h-16 max-w-[1400px] mx-auto">
            {/* Hamburger */}
            <button
              data-testid="header-hamburger-btn"
              onClick={() => setMenuOpen(true)}
              className="text-white/80 hover:text-white transition-colors p-2 -ml-2"
              aria-label="Open menu"
            >
              <Menu size={22} strokeWidth={1.6} />
            </button>

            {/* Center logo */}
            <Link
              to="/"
              data-testid="header-brand-logo"
              className="absolute left-1/2 -translate-x-1/2 flex items-center"
            >
              <img
                src="/aurora-logo.png"
                alt="Aurora"
                className="w-8 h-8 rounded-xl object-cover ring-1 ring-white/10"
              />
            </Link>

            {/* CTA */}
            <button
              data-testid="header-cta-btn"
              onClick={() => navigate(ctaHref)}
              className="group relative overflow-hidden rounded-full px-5 h-9 flex items-center gap-2 border border-white/15 bg-white/[0.04] hover:bg-white/[0.08] transition-all"
              style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}
            >
              <ShieldCheck size={14} className="text-[#FF3B6B]" />
              <span className="text-white text-xs font-medium tracking-wide">
                {ctaLabel}
              </span>
            </button>
          </div>
        </div>
      </header>

      <AuroraSlideMenu open={menuOpen} onClose={() => setMenuOpen(false)} />
    </>
  );
}
